export default __webpack_public_path__ + "static/04.01-b9af660ad2e6a130e64f667a31cbfc16.png";